import React from 'react';

import styled from 'styled-components';


import { MrRow,MrRowHeader, } from "../../components/UI/MrTable/MrTable";

import { MrColumn,MrColumnHeader } from "../../components/UI/MrTable/MrTable";




const DisorderHeader = props => {
    return (
            <MrRowHeader className="desktop-only" >
                <MrColumnHeader style={{flex: 2}}>Disorder Name</MrColumnHeader>
                <MrColumnHeader style={{flex: 2}}>Abreviation</MrColumnHeader>
                <MrColumnHeader style={{flex: 2}}>Symptoms</MrColumnHeader>
                <MrColumnHeader style={{flex: 2}}>Remarks</MrColumnHeader>
                <MrColumnHeader style={{flex: 2}}>Edit/Delete</MrColumnHeader>
            </MrRowHeader>

    );
};

export default DisorderHeader;


// style={{ 'overflow':'scroll'}}